import { InformationCircleIcon } from '@heroicons/react/24/outline';
import { BulleAide, Question, SmartButton } from '@workspace/core-ts/components';
import { SmartFormGlobal, useGlobalForm, useSmartFormGlobal } from '@workspace/core-ts/contexts';
import { CinquanteCm, Warning } from '@workspace/core-ts/icons-amo';
import { useSearchParams } from 'react-router-dom';
import VehiculesFields from '../components/vehicules';
import vehicules from '../content/3-vehicules';
import ModalVehiculeL1Uniquement from '@/components/modals/modal-vehicule-l1-uniquement';
import type { FormSchemaType } from '@/schema';

export default function Vehicules() {
  const methods = useSmartFormGlobal<FormSchemaType>();
  const setSearchParams = useSearchParams()[1];
  const {
    actions: { getContent },
  } = useGlobalForm();
  const isAvenant = methods.watch('DemandeTarif.ActeGestion') === 'AV';

  return (
    <>
      <ModalVehiculeL1Uniquement />
      <SmartFormGlobal
        {...methods}
        className="max-w-6xl mx-auto"
      >
        <Question.Header>
          <CinquanteCm />
          <Question.SubTitle>Véhicules</Question.SubTitle>
          <Question.Title>{getContent(vehicules.title)}</Question.Title>
          <button
            className="flex items-center gap-1 text-primary text-sm pt-1"
            onClick={() => setSearchParams({ modal: 'vehicule-l1-uniquement' })}
            type="button"
          >
            <InformationCircleIcon className="h-5 w-5" />
            Véhicule de catégorie L1e uniquement, en savoir plus ?
          </button>

          {isAvenant ? (
            <BulleAide
              icon={<Warning />}
              description={
                <span>
                  Si l'ajout de véhicules vise à remplacer une partie de votre flotte, <strong>pensez à d'abord sortir les véhicules concernés</strong> afin
                  d'obtenir le tarif correspondant à votre nouvelle situation !
                </span>
              }
              title="Conseil APRIL Moto"
            />
          ) : null}
        </Question.Header>

        <VehiculesFields />
        <SmartButton />
      </SmartFormGlobal>
    </>
  );
}
